import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import ModuleCategory from "./options_components/module_category";

const Container = styled.div`
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h3`
  display: inline-flex;
  align-items: center;
  margin: 0px 0px 20px 0px;
  font-weight: 300;
  font-size: 18px;
  @media (max-width: ${(props) => props.mobileBreakpoint ? props.mobileBreakpoint : 800}px) {
    font-size: 16px;
  }
`;

const ContentWrapper = styled.div`
  background-color: white;
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
`;

const standardize_color = (str) => {
  var ctx = document.createElement('canvas').getContext('2d');
  ctx.fillStyle = str;
  return ctx.fillStyle.length > 0 && ctx.fillStyle[0] === '#' ? ctx.fillStyle : rgb2hex(ctx.fillStyle);
}

const rgb2hex = (rgb) => {
  rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  return (rgb && rgb.length === 4) ? "#" +
    ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
    ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
    ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
}

const hexToRgb = hex =>
  hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i
    , (m, r, g, b) => '#' + r + r + g + g + b + b)
    .substring(1).match(/.{2}/g)
    .map(x => parseInt(x, 16));


const rgb_is_light = (color) => {
  const brightness = ((color[0] * 299) + (color[1] * 587) + (color[2] * 114)) / 1000;
  return brightness > 155;
}

export const OPTIONS_SELECTOR_DISPLAY_MODES = {
  CLASSIC: 0,
  DROPDOWN: 1
};

const AVAILABLE_DISPLAY_MODES = {
  [OPTIONS_SELECTOR_DISPLAY_MODES.CLASSIC]: true,
  [OPTIONS_SELECTOR_DISPLAY_MODES.DROPDOWN]: true
}

class OptionsSelector extends React.Component {
  static propTypes = {
    moduleCategories: PropTypes.array,
    unfilteredModuleCategories: PropTypes.array,
    isSaving: PropTypes.bool,
    getLabel: PropTypes.func,
    getAndReplaceLabel: PropTypes.func,
    renderProductLink: PropTypes.func,
    mobileBreakpoint: PropTypes.number,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    categoryDisplayMode: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      primaryTextColor: rgb_is_light(hexToRgb(standardize_color(props.primaryColor || '#008a16'))) ? 'rgb(98,100,105)' : 'white',
      secondaryTextColor: rgb_is_light(hexToRgb(standardize_color(props.secondaryColor || '#42B4E6'))) ? 'rgb(98,100,105)' : 'white',
    };
  }

  getCategoryDisplayMode = () => {
    if (AVAILABLE_DISPLAY_MODES[this.props.categoryDisplayMode] != null) {
      return this.props.categoryDisplayMode;
    }
    return OPTIONS_SELECTOR_DISPLAY_MODES.CLASSIC;
  }

  nbModulesWithAccessories = (islandCategory) => {
    let result = 0;
    Object.keys(islandCategory.moduleItems).forEach((islandCategoryKey) => {
      const category = islandCategory.moduleItems[islandCategoryKey];
      category.modules.forEach((mod) => {
        if (mod.device.accessoriesId().length > 0) {
          result += 1;
        }
      });
    });
    return result;
  };

  nbModulesToAccessorize = (islandCategory) => {
    let result = 0;
    Object.keys(islandCategory.moduleItems).forEach((islandCategoryKey) => {
      const category = islandCategory.moduleItems[islandCategoryKey];
      result += category.modules.length;
    });

    return result;
  };

  setWrapperRef = (element) => {
    this.wrapperElement = element;
  };

  render = () => {
    const categoryDisplayMode = this.getCategoryDisplayMode();
    return (
      <Container ref={this.setWrapperRef}>
        <ContentWrapper>
          {categoryDisplayMode === OPTIONS_SELECTOR_DISPLAY_MODES.CLASSIC && <TitleWrapper>
            <Title mobileBreakpoint={this.props.mobileBreakpoint}>
              {this.props.getLabel('options.device_choice_options')}
            </Title>
          </TitleWrapper>}
          {this.props.moduleCategories.map((category, idx) => {
            return (
              <ModuleCategory
                key={idx}
                moduleCategory={category}
                isSaving={this.props.isSaving}
                renderProductLink={this.props.renderProductLink}
                mobileBreakpoint={this.props.mobileBreakpoint}
                primaryColor={this.props.primaryColor}
                primaryTextColor={this.state.primaryTextColor}
                secondaryColor={this.props.secondaryColor}
                secondaryTextColor={this.state.secondaryTextColor}
                getLabel={this.props.getLabel}
                getAndReplaceLabel={this.props.getAndReplaceLabel}
                categoryDisplayMode={categoryDisplayMode}
              ></ModuleCategory>
            );
          })}
        </ContentWrapper>
      </Container>
    );
  };
}

export default OptionsSelector;
